import React from 'react';
import EImg from './EImg';

export default ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Go Up!"
		aria-label="Emoji: Go Up!"
		alt="👆"
		src="https://abs.twimg.com/emoji/v2/72x72/1f446.png"
	/>
);
